import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"

import { ALIGN, RATIO } from "../../contentful/globals"

export const MAX = {
  M_1_10: 0.1,
  M_1_5: 0.2,
  M_1_4: 0.25,
  M_1_3: 0.33333333,
  M_1_2: 0.5,
  M_3_4: 0.75,
  M_9_10: 0.9,
  M_1_1: 1,
}

export default class AspectRatio extends React.Component {

  state = {
    width: 100,
    height: 100
  }

  componentDidMount() {
    const _this = this
    _this.onResize()
    window.addEventListener('resize', () => _this.onResize())
  }

  componentWillUnmount() {
    const _this = this
    window.removeEventListener('resize', () => _this.onResize())
  }

  onResize = () => {

    const { ratio, max } = this.props
    let w = 0
    let h = 0
    let vh = 0

    if (typeof window !== 'undefined') {
      vh = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    }

    if (ratio === RATIO.R_1_1) {
      w = vh
      h = vh
    }

    if (ratio === RATIO.R_1_2) {
      w = vh / 2
      h = vh
    }

    if (ratio === RATIO.R_2_1) {
      w = vh * 2
      h = vh
    }

    if (ratio === RATIO.R_3_4) {
      w = vh * 3 / 4
      h = vh
    }

    if (ratio === RATIO.R_4_3) {
      w = 4 / 3 * vh
      h = vh
    }

    if (ratio === RATIO.R_26_14) {
      w = 26 / 14.1 * vh
      h = vh
    }

    if (ratio === RATIO.R_16_9) {
      w = 16 / 9 * vh
      h = vh
    }

    if (ratio === RATIO.R_9_16) {
      w = vh * 9 / 16
      h = vh
    }

    if (ratio === RATIO.R_21_9) {
      w = 21 / 9 * vh
      h = vh
    }

    if (ratio === RATIO.R_9_21) {
      w = vh * 9 / 21
      h = vh
    }

    w = Math.round(w * max)
    h = Math.round(h * max)

    this.setState({ width: w, height: h })

  }

  render() {

    const { children, align, debug } = this.props

    return (
      <Container
        width={this.state.width}
        height={this.state.height}
        align={align}
        debug={debug}
      >
        {children}
      </Container>
    )

  }

}

const Container = styled.div`
  width:100%;
  height:auto;
  position:relative;
  margin-left:auto;
  margin-right:auto;
  ${props => props.debug === true ? `background-color:red;` : ``}

  ${up('md')}{
    position: relative;
    width:${props => props.width}px;
    height:${props => props.height}px;

    ${props => props.align === ALIGN.TOP ? `align-self:flex-start;` : ``}
    ${props => props.align === ALIGN.MIDDLE ? `align-self:center;` : ``}
    ${props => props.align === ALIGN.BOTTOM ? `align-self:flex-end;` : ``}

    @media (min-height: 400px) {
      /* background-color:red; */
    }
    
    @media (min-height: 600px) {
      /* background-color:orange; */
    }
    
    @media (min-height: 800px) {
      /* background-color:yellow; */
      /* transform:scale(.9); */
    }
    
    @media (min-height: 1000px) {
      /* background-color:blue; */
      /* transform:scale(.8); */
    }

  }
`

